import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=73bc3d17&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
import style0 from "./Edit.vue?vue&type=style&index=0&id=73bc3d17&prod&lang=scss&scoped=true"
import style1 from "./Edit.vue?vue&type=style&index=1&id=73bc3d17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc3d17",
  null
  
)

export default component.exports